// Copyright (c) Move Closer 2022.

import { IModuleConstructor } from '@movecloser/front-core'

import { AnalyticsModule } from './analytics/module'
import { AuthModule } from './auth/module'
import { CheckoutModule } from './checkout/module'
import { LoyaltyModule } from './loyalty/module'
import { OrdersModule } from './orders/module'
import { ProductsModule } from './products/module'
import { ProfileModule } from './profile/module'
import { SharedModule } from './shared/module'
import { RootModule } from './root/module'
import { WishListModule } from './wishlist/module'
import { PoiModule } from './poi/module'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export const frontAppModules: IModuleConstructor[] = [
  SharedModule,
  // Here goes app modules:
  AnalyticsModule,
  AuthModule,
  CheckoutModule,
  LoyaltyModule,
  OrdersModule,
  PoiModule,
  ProductsModule,
  ProfileModule,
  RootModule,
  WishListModule
]
